<template>
  <v-container fluid>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row wrap>
        <v-col cols="12" class="headline pl-0">
          New Dump Ticket
        </v-col>
      </v-row>
      <!-- DUMP DETAILS -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1 pt-3">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-select
                      :items="[
                        'JD Recycling',
                        'Cooper Tank',
                        'Allocco recycling',
                        'Benson Scrap Metal',
                        'Deer Park Recycling',
                        'Point Recycling',
                        'Regal Recycling',
                        'Richmond Recycling',
                        'Zevel Transfer',
                        'TNT Scrap',
                        'Sals Scrap',
                        'Gaeta Recycling',
                        'Boro-Wide Recycling',
                        'AJ Recycling',
                        'Sims metal',
                        'America Recycling',
                        'Other',
                      ]"
                      v-model="dumpSite"
                      label="Dump Site"
                      prepend-icon="terrain"
                      required
                      dense
                      :rules="[(v) => !!v || 'Dump Site is required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-text-field
                      label="Ticket Number"
                      v-model="ticketNumber"
                      type="text"
                      prepend-icon="receipt"
                      dense
                      required
                      :rules="[(v) => !!v || 'Ticket Number is required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-text-field
                      label="Load Weight"
                      v-model.number="loadWeight"
                      type="number"
                      prepend-icon="monitor_weight"
                      dense
                      required
                      :rules="[(v) => !!v || 'Load Weight is required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-select
                      label="Weight Type"
                      :items="['Tons', 'Cubic Yards', 'Pounds']"
                      v-model="loadWeightType"
                      type="text"
                      dense
                      required
                      prepend-icon="monitor_weight"
                      :rules="[(v) => !!v || 'Load Weight Type is required']"
                      :hint="weightMessage || ''"
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-text-field
                      label="Yards"
                      v-model.number="yards"
                      type="number"
                      prepend-icon="format_list_numbered"
                      dense
                      required
                      :rules="[(v) => !!v || 'Yards is required']"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- SELECT TRUCK REQUESTS -->
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1 pt-0">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <h3 class="mb-4">Select Truck Requests</h3>
                    <v-select
                      id="trSelector"
                      v-model="selectedRequests"
                      :items="truckRequests"
                      return-object
                      item-text="orderNumber"
                      label="Select Truck Requests"
                      :rules="[(v) => !!v.length || 'Truck request required']"
                      multiple
                      dense
                    >
                      <template v-slot:item="{ item }">
                        <template>
                          <v-checkbox
                            :value="
                              selectedRequests.some(
                                (sr) => sr.orderNumber == item.orderNumber
                              )
                            "
                          ></v-checkbox>
                          <v-list-item-content class="py-1">
                            <v-list-item-title class="py-4">
                              <div style="font-size: 1em">
                                {{ item.jobSite.street }}
                              </div>
                              <div
                                class="mr-2 font-weight-regular caption"
                                v-if="user.role !== 'Driver'"
                              >
                                {{ item.requestType }}
                              </div>
                              <div
                                class="mr-2 font-weight-regular caption"
                                v-if="user.role !== 'Driver'"
                              >
                                Driver:
                                <strong
                                  >{{ item.scheduledDriver.firstName }}
                                  {{ item.scheduledDriver.lastName }}</strong
                                >
                              </div>
                              <div class="caption" v-if="item.scheduledDay">
                                Scheduled:
                                <strong>{{
                                  item.scheduledDay.displayDate2
                                }}</strong>
                              </div>
                              <div class="caption" v-if="item.scheduledDay">
                                Pickup Type:
                                <strong>{{ item.pickupType }}</strong>
                              </div>
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" xs="12" v-if="selectedRequests.length">
                    <h3 class="mb-4">Details on selected truck requests</h3>
                    <div
                      v-for="r in selectedRequests"
                      style="background-color:#f1f1f1"
                      :key="r.orderNumber"
                      class="mb-4 pa-2"
                    >
                      <h4>Request #{{ r.orderNumber }}</h4>
                      <strong>{{ r.jobSite.address }}</strong>
                      <truck-request-details :order="r" :showNotes="false" />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <div style="width:100%">
                      <v-file-input
                        max-width="100%"
                        hint="Add Dump Ticket Image"
                        multiple
                        persistent-hint
                        v-model="files"
                        @change="imagesLoaded"
                        accept="image/*"
                        dense
                      ></v-file-input>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    v-for="(furl, ix) in fileData"
                    :key="ix"
                  >
                    <v-img
                      :src="furl.imageUrl"
                      height="150"
                      width="150"
                      contain
                    />
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-btn
                      block
                      color="primary"
                      @click="submitDumpTicket"
                      :disabled="!valid || loading"
                      :loading="loading"
                    >
                      <v-icon left>file_upload</v-icon>Submit Dump Ticket
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog
      v-model="loading"
      persistent
      width="350"
      overlay-opacity=".5"
      overlay-color="white"
    >
      <v-card color="primary" dark>
        <v-card-text>
          <v-card-text>
            <div class="text-center"><v-icon large>image</v-icon></div>
            <h2 class="title mb-4 white--text font-weight-regular">
              Your dump ticket is being submitted...Please wait.
            </h2>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import truckRequestDetails from "@/components/truckRequests/truckRequestDetails";
export default {
  components: {
    truckRequestDetails,
  },
  data: () => ({
    dumpSite: "",
    loadWeight: null,
    loadWeightType: null,
    ticketNumber: null,
    selectedRequests: [],
    truckRequests: [],
    files: [],
    fileData: [],
    valid: true,
    snack: false,
    snackColor: "",
    snackText: "",
    loading: false,
    fetchingMessage: "Loading uploaded sign in sheets.",
    yards: null,
  }),
  async created() {
    this.getTruckRequests();
  },
  computed: {
    weightMessage: function() {
      if (this.loadWeightType === "Tons" && this.loadWeight > 100) {
        return "DID YOU MEAN POUNDS?";
      } else if (this.loadWeightType === "Pounds" && this.loadWeight < 100) {
        return "DID YOU MEAN TONS?";
      } else {
        return "";
      }
    },
    ...mapState(["user"]),
  },
  mounted() {
    // fix for v-file-input not triggering properly
    setTimeout(() => {
      let inputs = document.querySelectorAll(".v-file-input input");
      [...inputs].forEach((input) => {
        input.remove();
      });
    }, 750);
  },
  methods: {
    imagesLoaded() {
      if (this.files.length) {
        this.files.forEach((file) => {
          const fr = new FileReader();
          fr.readAsDataURL(file);
          fr.addEventListener("load", () => {
            this.fileData.push({
              imageUrl: fr.result,
              image: file,
            });
          });
        });
      } else {
        this.fileData = [];
      }
    },
    async submitDumpTicket() {
      if (!this.fileData.length) {
        alert("Please add dump ticket photo before submitting.");
        return;
      }
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          const snapshots = await fb.dumpTicketsStorage
            .ref()
            .putFiles(this.fileData.map((f) => f.image));
          // Get an array of file metadata
          const downloadUrls = await Promise.all(
            snapshots.map(function(r) {
              return r.ref.getDownloadURL();
            })
          );
          const payload = {};
          const id = `dumpTickets.${moment().unix()}`;
          if (this.loadWeightType == "Tons" && this.loadWeight > 100) {
            this.loadWeightType = "Pounds";
          }
          if (this.loadWeightType == "Pounds" && this.loadWeight <= 100) {
            this.loadWeightType = "Tons";
          }
          const dumpTicketData = {
            dumpTicketBy: this.user,
            dumpTicketImage: downloadUrls,
            createDate: fb.timestamp,
            loadWeight: this.loadWeight,
            loadWeightType: this.loadWeightType,
            ticketNumber: this.ticketNumber,
            price: 0,
            dumpSite: this.dumpSite,
            yards: this.yards || 0,
          };
          payload[id] = dumpTicketData;

          const batch = fb.db.batch();
          this.selectedRequests.forEach((tr) => {
            var ref = fb.db.doc(`truckRequests/${tr.orderNumber}`);
            batch.update(ref, payload);
          });
          await batch.commit();
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Successfully uploaded and saved!";
          this.files = [];
          this.fileData = [];
          this.loadWeight = null;
          this.loadWeightType = null;
          this.ticketNumber = null;
          this.selectedRequests = [];
          this.dumpSite = null;
          this.loading = false;
          this.yards = null;
          this.$refs.form.reset();
          this.getTruckRequests();
        } catch (error) {
          alert(error.message);
          this.loading = false;
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Error uploading images!";
        }
      }
    },
    async getTruckRequests() {
      let ref;
      if (this.user.role == "Driver") {
        ref = fb.db
          .collection("truckRequests")
          .where("status", "==", "closed")
          .where("scheduledDriver.id", "==", this.user.uid)
          .orderBy("orderDate", "desc")
          .limit(80);
      } else {
        ref = fb.db
          .collection("truckRequests")
          .where("status", "==", "closed")
          .orderBy("orderDate", "desc")
          .limit(300);
      }
      const truckRequestsRes = await ref.get();
      const truckRequests = [];
      truckRequestsRes.forEach((u) => {
        truckRequests.push({
          ...u.data(),
        });
      });
      this.truckRequests = truckRequests.filter((tr) => {
        if (tr.dumpTickets) {
          return false;
        }
        if (tr.requestType === "Mini Pickup/Dropoff") {
          return false;
        }
        if (tr.pickupType === "Drop Off Container") {
          return false;
        }
        return true;
      });
    },
  },
};
</script>

<style>
.v-messages__message {
  color: red !important;
}
</style>
